











import {Component, Prop, Vue, Watch} from 'vue-property-decorator';

@Component({})
export default class App extends Vue {
  private created() {
    this.$store.dispatch('checkOnline');
  }

  private get online() {
    return this.$store.getters.online;
  }
}
